module.exports = __webpack_public_path__ + "img/bg.78d243f3.jpg";